import { render, staticRenderFns } from "./_price.vue?vue&type=template&id=0c863556"
import script from "./_price.vue?vue&type=script&lang=js"
export * from "./_price.vue?vue&type=script&lang=js"
import style0 from "./_price.vue?vue&type=style&index=0&id=0c863556&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports